import { Tour as ANTDTour, TourStepProps as ANTDTourStepProps } from 'antd';
import { useMemo } from 'react';
import { createGlobalStyle, css, useTheme } from 'styled-components';

import { Icon } from '../../ui';
import { rem } from '../../utils/';

const TOUR_PRESETS = {
  container: {
    width: 290,
  },
  title: {
    paddingRight: 20,
  },
};

export interface TourProps {
  steps: ANTDTourStepProps[];
  showArrow?: boolean;
  mask?: boolean;
  open?: boolean;
  onClose?: () => void;
  onFinish?: () => void;
  width?: number | string;
  onChange?: (current: number) => void;
  current?: number;
}

const TourGlobalStyle = createGlobalStyle<{
  width?: TourProps['width'];
}>`
  ${({ width, theme }) => css`
    .ant-tour {
      width: ${rem(width && typeof width === 'number' ? width : TOUR_PRESETS.container.width)};
    }

    .ant-tour-title {
      padding-right: ${rem(TOUR_PRESETS.title.paddingRight)};
    }

    .ant-tour-buttons:not(.ant-tour-indicators + .ant-tour-buttons) {
      margin-inline-start: initial !important;
      .ant-btn {
        margin-inline-start: 0 !important;
      }
    }
    .ant-tour-prev-btn {
      :hover {
        color: ${theme.Color.Neutrals.Text};
      }
    }
  `}
`;

export function Tour({
  open = true,
  steps,
  showArrow = true,
  mask = false,
  variant,
  onClose,
  onFinish,
  width,
  current,
  onChange,
}: TourProps & { variant: 'noImage' | 'withImage' }) {
  const theme = useTheme();
  const newSteps = useMemo(() => {
    return steps.map((step) => {
      if (variant === 'noImage') {
        return {
          ...step,
          cover: null,
        } as ANTDTourStepProps;
      }

      return step;
    });
  }, [steps, variant]);

  return (
    <>
      <TourGlobalStyle width={width} />
      <ANTDTour
        open={open}
        arrow={showArrow}
        current={current}
        onChange={onChange}
        onFinish={onFinish}
        closeIcon={
          <Icon
            name="cross"
            color={theme.Color.Neutrals.Text}
            highlightColor={theme.Color.NeutralsFixed.Paper}
          />
        }
        steps={newSteps}
        mask={mask}
        onClose={onClose}
      />
    </>
  );
}
